export default {
  'menu.videoOperations': '视频运营',
  'menu.login': '登录',
  'menu.account.logout': '退出登录',
  'menu.account.switch-admin': '切换身份',
  'menu.merchant': '商户管理',
  'menu.merchant.brand': '品牌管理',
  'menu.merchant.store': '门店管理',
  'menu.merchant.wechatSpConfig': '微信服务商配置',
  'menu.merchant.alipaySpConfig': '支付宝服务商配置',
  'menu.merchant.subMerchant': '二级商户配置',
  'menu.system': '系统管理',
  'menu.system.menu': '菜单管理',
  'menu.userManagement': '用户管理',
  'menu.userManagement.role': '角色管理',
  'menu.userManagement.publicRole': '公共角色管理',
  'menu.userManagement.admin': '管理员管理',
  'menu.userManagement.coach': '助教管理',
  'menu.equipment': '设备管理',
  'menu.equipment.table': '球桌管理',
  'menu.equipment.device': '设备管理',
  'menu.equipment.scoreboardCode': '开播码管理',
  'menu.match': '比赛管理',
  'menu.match.list': '比赛列表',
  'menu.match.detail': '比赛详情',
  'menu.product': '商品管理',
  'menu.product.category': '商品分类',
  'menu.product.list': '商品列表',
  'menu.order': '订单管理',
  'menu.order.tableOrder': '订单列表',
  'menu.order.refund': '退款管理',
  'menu.openPlatform': '开放管理',
  'menu.openPlatform.openApp': '开放配置',
  'menu.openPlatform.callbackLogs': '回调日志',
  'menu.openPlatform.apiLogs': 'API调用日志',
  'menu.finance': '财务中心',
  'menu.finance.profitReceiver': '分账接收方',
  'menu.finance.brandProfitPreset': '品牌分账预设',
  'menu.finance.storeProfitRule': '门店分账规则',
  'menu.finance.profitSharing': '分账记录',
  'menu.finance.profitSharingReturn': '退分账记录',
  'menu.finance.fundAccount': '资金账户',
  'menu.statistics': '经营分析',
  'menu.statistics.orderRevenue': '订单营收统计',
};
